module.exports = __webpack_public_path__ + "media/images/resource/cart-6-c327c0d76615b186f0df008700be8f9c.png";